import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "organ-ueser-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "search-form",
  style: {
    "margin-bottom": "15px"
  }
};
const _hoisted_4 = {
  class: "user-table"
};
import { reactive, ref, markRaw, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import organUserDialog from "./components/organ-user-dialog.vue";
import { getAllOrganLis1tApi, getAllOrganUserApi } from "@/service/modules/organ";
import { QuestionFilled } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { addLoading } from "@/utils/element-method";
import protoPagination from "@/components/proto-pagination.vue";
import { updateOrganUserByIdApi, deleteOrganUserByIdApi } from "@/service/modules/organ";
import UserBindDialog from "./components/user-bind-dialog.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'organ-user',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const organUserDialogVisible = ref(false);
    const organUserDialogType = ref("add");
    const organUserItemData = ref({});
    const organList = ref([]);
    const page = reactive({
      current: 1,
      size: 10
    });
    const institutionId = ref(null); // 机构id
    const userList = ref([]); // 机构人员列表
    const total = ref(0); // 机构人员总数
    const bindDialogVisible = ref(false);
    const organId = ref("");
    getOrganList();
    async function getOrganList() {
      try {
        let res = await getAllOrganLis1tApi();
        organList.value = res.data.data;
      } catch {}
    }
    getAllOrganUser();
    async function getAllOrganUser() {
      let instance = addLoading(".user-table");
      try {
        let query = JSON.parse(JSON.stringify(page));
        delete query.limit;
        let res = await getAllOrganUserApi(query);
        userList.value = res.data.members_list;
        total.value = res.data.total;
      } catch {} finally {
        instance.close();
      }
    }
    function handleOrganUserTableCurrentChange(val) {
      page.current = val;
      getAllOrganUser();
    }
    function restData() {
      page.size = 10;
      getAllOrganUser();
    }
    async function handleSearchByOrgan() {
      // console.log('institutionId', institutionId.value)
      page.current = 1;
      let query = JSON.parse(JSON.stringify(page));
      delete query.limit;
      if (institutionId.value) {
        query.institutionId = institutionId.value;
      }
      let instance = addLoading(".user-table");
      try {
        let res = await getAllOrganUserApi(query);
        userList.value = res.data.members_list;
        total.value = Number(res.data.total);
      } catch {} finally {
        instance.close();
      }
    }
    function handleUpdateUserItem(item) {
      organUserDialogType.value = "edit";
      organUserItemData.value = item;
      organUserDialogVisible.value = true;
    }
    async function handleChangeUserStatus(item) {
      let id = item.id;
      let query = JSON.parse(JSON.stringify(item));
      delete query.id;
      try {
        await updateOrganUserByIdApi(id, query);
        ElMessage.success("操作成功");
      } catch {} finally {
        restData();
      }
    }
    function handleDeleteUserItem(id) {
      ElMessageBox.confirm("此操作将永久删除该数据, 是否继续？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deleteOrganUserByIdApi(id);
          ElMessage.success("删除成功");
          restData();
        } catch {}
      }).catch(() => {});
    }
    function handleOpenOdganUserDialog() {
      organUserDialogType.value = "add";
      organUserItemData.value = {};
      organUserDialogVisible.value = true;
    }
    function handleCloseOrganUserDialog() {
      organUserDialogType.value = "add";
      organUserItemData.value = {};
      organUserDialogVisible.value = false;
    }
    onMounted(() => {
      if (route.params.id) {
        organId.value = route.params.id;
        getUserList();
      }
    });
    const getUserList = () => {
      loading.value = true;
      // 模拟API请求
      setTimeout(() => {
        userList.value = [{
          id: 1,
          name: "张三",
          account: "zhangsan",
          phone: "13800138001",
          role: "管理员"
        }, {
          id: 2,
          name: "李四",
          account: "lisi",
          phone: "13800138002",
          role: "运营"
        }];
        total.value = 2;
        loading.value = false;
      }, 500);
    };
    const handleSearch = () => {
      page.page = 1;
      getUserList();
    };
    const resetSearch = () => {
      searchForm.keyword = "";
      page.current = 1;
      getUserList();
    };
    const handleCurrentChange = val => {
      page.current = val;
      getUserList();
    };
    const handleBindUser = () => {
      bindDialogVisible.value = true;
    };
    const handleBindSuccess = users => {
      console.log("绑定成功", users);
      getUserList(); // 刷新列表
    };
    const handleUnbind = row => {
      ElMessageBox.confirm(`确定要解绑 ${row.name} 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 模拟API请求
        setTimeout(() => {
          ElMessage.success("解绑成功");
          getUserList(); // 刷新列表
        }, 500);
      }).catch(() => {
        // 取消操作
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createTextVNode(" 机构人员 ")), _createVNode(_component_el_button, {
        onClick: handleOpenOdganUserDialog,
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("新增")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
        modelValue: institutionId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => institutionId.value = $event),
        filterable: "",
        clearable: "",
        onClear: handleSearchByOrgan,
        onChange: handleSearchByOrgan,
        placeholder: "请选择机构",
        style: {
          "width": "200px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.name,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
        data: userList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        empty: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          width: "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.current - 1) * page.size), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "realname",
          label: "姓名",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "手机号码",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "institution_name",
          label: "所属机构",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            onClick: $event => handleUpdateUserItem(scope.row),
            type: "primary"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => handleDeleteUserItem(scope.row.id)
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(protoPagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleOrganUserTableCurrentChange
      }, null, 8, ["page", "total"])])]), _createVNode(organUserDialog, {
        "dialog-visible": organUserDialogVisible.value,
        "dialog-type": organUserDialogType.value,
        "item-data": organUserItemData.value,
        "organ-list": organList.value,
        onCloseDialog: handleCloseOrganUserDialog,
        onRestData: restData
      }, null, 8, ["dialog-visible", "dialog-type", "item-data", "organ-list"]), _createVNode(UserBindDialog, {
        dialogVisible: bindDialogVisible.value,
        "onUpdate:dialogVisible": _cache[1] || (_cache[1] = $event => bindDialogVisible.value = $event),
        "organ-id": organId.value,
        onSuccess: handleBindSuccess
      }, null, 8, ["dialogVisible", "organ-id"])], 64);
    };
  }
});